(() => {
  if (window.llAnnouncementOffsetReady) return;
  window.llAnnouncementOffsetReady = true;

  let observedBar = null;
  let scheduled = false;
  const observer = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;

  function update() {
    scheduled = false;
    const bar = document.querySelector('[data-ll-announcement-bar]');
    if (bar !== observedBar) {
      if (observer && observedBar) observer.unobserve(observedBar);
      if (observer && bar) observer.observe(bar);
      observedBar = bar;
    }
    const offset = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--ll-announcement-offset', `${offset}px`);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  schedule();
})();
